import React from "react";
import ReactMarkdown from "react-markdown";
import { Button } from "@/components/ui/button";
import type { CourseNodeContent, ConceptContent } from "@/types/courses";

interface ConceptStepProps {
  step: CourseNodeContent;
  conceptIndex: number;
  totalConcepts: number;
  onContinue: () => void;
}

const ConceptStep: React.FC<ConceptStepProps> = ({
  step,
  conceptIndex,
  totalConcepts,
  onContinue,
}) => {
  const content = step.content as ConceptContent;
  return (
    <div className="rounded-2xl border bg-card p-6 space-y-4">
      <p className="text-xs text-muted-foreground">
        Step {conceptIndex} of {totalConcepts}
      </p>
      <h2 className="text-lg font-semibold">Key idea</h2>
      <div className="rounded-xl bg-muted/40 p-5">
        <div className="prose prose-sm dark:prose-invert max-w-none [&>p>strong:first-child]:mt-4 [&>p>strong:first-child]:block">
          <ReactMarkdown>{content.text}</ReactMarkdown>
        </div>
      </div>
      <Button variant="secondary" className="w-full" onClick={onContinue}>
        Continue
      </Button>
    </div>
  );
};

export default ConceptStep;
